
/**
 * The type of the action which signals to add a new chat message.
 *
 * {
 *     type: ADD_MESSAGE,
 *     displayName: string
 *     hasRead: boolean,
 *     id: string,
 *     messageType: string,
 *     message: string,
 *     timestamp: string,
 * }.
 */
export const ADD_MESSAGE = 'ADD_MESSAGE';

/**
 * The type of the action which signals to clear messages in Redux.
 *
 * {
 *     type: CLEAR_MESSAGES
 * }.
 */
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';

/**
 * The type of the action which signals to send an edit for an existing chat message (XEP-0308).
 * Works for both group and private messages.
 *
 * {
 *     type: SEND_EDIT_MESSAGE,
 *     messageId: string,
 *     message: string,
 *     recipientId?: string  // For private messages, the participant id of the recipient
 * }
 */
export const SEND_EDIT_MESSAGE = 'SEND_EDIT_MESSAGE';

/**
 * The type of the action which signals the cancellation the chat panel.
 *
 * {
 *     type: CLOSE_CHAT
 * }.
 */
export const CLOSE_CHAT = 'CLOSE_CHAT';

/**
 * The type of the action which signals to edit chat message.
 *
 * {
 *     type: EDIT_MESSAGE,
 *     message: Object
 * }
 */
export const EDIT_MESSAGE = 'EDIT_MESSAGE';

/**
 * The type of the action which signals to display the chat panel.
 *
 * {
 *     type: OPEN_CHAT
 * }.
 */
export const OPEN_CHAT = 'OPEN_CHAT';

/**
 * The type of the action which signals to display the polls panel.
 *
 * {
 *     type: OPEN_POLLS
 * }.
 */
export const OPEN_POLLS = 'OPEN_POLLS';

/**
 * The type of the action which signals to close the polls panel.
 *
 * {
 *     type: CLOSE_POLLS
 * }.
 */
export const CLOSE_POLLS = 'CLOSE_POLLS';

/**
 * The type of the action which signals a send a chat message to everyone in the
 * conference.
 *
 * {
 *     type: SEND_MESSAGE,
 *     ignorePrivacy: boolean,
 *     message: string
 * }.
 */
export const SEND_MESSAGE = 'SEND_MESSAGE';

/**
 * The type of action which signals the initiation of sending of as private message to the
 * supplied recipient.
 *
 * {
 *     participant: Participant,
 *     type: SET_PRIVATE_MESSAGE_RECIPIENT
 * }.
 */
export const SET_PRIVATE_MESSAGE_RECIPIENT = 'SET_PRIVATE_MESSAGE_RECIPIENT';

/**
 * The type of action which signals the update a _isPollsTabFocused.
 *
 * {
 *     isPollsTabFocused: boolean,
 *     type: SET_PRIVATE_MESSAGE_RECIPIENT
 * }.
 */
export const SET_IS_POLL_TAB_FOCUSED = 'SET_IS_POLL_TAB_FOCUSED';

/**
 * The type of action which sets the current recipient for lobby messages.
 *
 * {
 *     participant: Object,
 *     type: SET_LOBBY_CHAT_RECIPIENT
 * }
 */
export const SET_LOBBY_CHAT_RECIPIENT = 'SET_LOBBY_CHAT_RECIPIENT';

/**
 * The type of action sets the state of lobby messaging status.
 *
 * {
 *     type: SET_LOBBY_CHAT_ACTIVE_STATE
 *     payload: boolean
 * }
 */
export const SET_LOBBY_CHAT_ACTIVE_STATE = 'SET_LOBBY_CHAT_ACTIVE_STATE';

/**
 * The type of action removes the lobby messaging from participant.
 *
 * {
 *     type: REMOVE_LOBBY_CHAT_PARTICIPANT
 * }
 */
export const REMOVE_LOBBY_CHAT_PARTICIPANT = 'REMOVE_LOBBY_CHAT_PARTICIPANT';

/**
 * The type of action which deletes a chat message.
 *
 * {
 *     type: DELETE_MESSAGE,
 *     messageId: string
 * }
 */
export const DELETE_MESSAGE = 'DELETE_MESSAGE';

/**
 * The type of action which restores a chat message.
 *
 * {
 *     type: RESTORE_MESSAGE,
 *     messageId: string
 * }
 */
export const RESTORE_MESSAGE = 'RESTORE_MESSAGE';


/**
 * The type of action which opens the image preview modal.
 *
 * {
 *     type: OPEN_IMAGE_PREVIEW,
 *     imageUrl: string,
 *     fileName: string
 * }
 */
export const OPEN_IMAGE_PREVIEW = 'OPEN_IMAGE_PREVIEW';

/**
 * The type of action which closes the image preview modal.
 *
 * {
 *     type: CLOSE_IMAGE_PREVIEW
 * }
 */
export const CLOSE_IMAGE_PREVIEW = 'CLOSE_IMAGE_PREVIEW';

/**
 * The type of action which disables or enables private chat.
 *
 * {
 *     type: SET_PRIVATE_CHAT_DISABLED,
 *     disabled: boolean
 * }
 */
export const SET_PRIVATE_CHAT_DISABLED = 'SET_PRIVATE_CHAT_DISABLED';
